type TApiError = {
  msg?: string
}

const SSML_CUSTOM_MESSAGE = 'Ошибка в SSML-разметке. Проверьте правильность тегов и структуры текста.'
const EMOTION_CUSTOM_MESSAGE = 'Выбранная эмоция недоступна для этого голоса или указано неверное имя эмоции.'
const SEED_CUSTOM_MESSAGE = 'Параметр seed должен быть целым числом от 1 до 50. Проверьте введённое значение.'
const ACCESS_CUSTOM_MESSAGE = 'Нет доступа'

const VOICE_PARAMETER_KEY = "The 'voice' parameter must be one of the following:"
const EMOTION_PARAMETER_KEY = "The 'emotion' parameter must be one of the following:"
const VOICE_SUPPORT_KEY = 'The voice does not support emotions.'
const SEED_ERROR_KEY = "The 'seed' parameter must be an integer in the range"
const SSML_ERROR_KEY = 'Incorrect SSML input, please, check your text.'
const ACCESS_ERROR_KEY = 'Access forbidden.'

const ERROR_KEYS = new Map<string, string>([
  [VOICE_PARAMETER_KEY, EMOTION_CUSTOM_MESSAGE],
  [EMOTION_PARAMETER_KEY, EMOTION_CUSTOM_MESSAGE],
  [VOICE_SUPPORT_KEY, EMOTION_CUSTOM_MESSAGE],
  [SEED_ERROR_KEY, SEED_CUSTOM_MESSAGE],
  [SSML_ERROR_KEY, SSML_CUSTOM_MESSAGE],
  [ACCESS_ERROR_KEY, ACCESS_CUSTOM_MESSAGE],
])

export const resolveTtsErrorMessage = (error: string): string => {
  const normalizedMessage = error.toLowerCase()

  for (const [key, customMessage] of ERROR_KEYS.entries()) {
    if (normalizedMessage.includes(key.toLowerCase())) {
      return customMessage
    }
  }

  return error
}

export const extractErrorMessage = (error: TApiError | undefined): string => {
  return error?.msg ?? 'Неизвестная ошибка'
}
